export default __webpack_public_path__ + "static/cro-26155262d4783c9ea29ae0bf9a0b5d9b.svg";